import type { CSSProperties } from 'react';
import { Outlet } from 'react-router-dom';
import { AppSidebar } from '@/widgets/app-sidebar';
import { SidebarInset, SidebarProvider } from '@/shared/ui/shadcn/sidebar';

const menuSidebarWidth = {
  '--sidebar-width': '12.8rem',
} as CSSProperties;

export function AppLayout() {
  return (
    <SidebarProvider
      className="h-dvh overflow-hidden pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]"
      style={menuSidebarWidth}
    >
      <AppSidebar />
      <SidebarInset className="relative min-h-0 overflow-hidden">
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  );
}
